<template>
  <div class="pt-2 w-100">
    <div
      v-if="error"
      class="text-danger text-center font-weight-bold pb-2"
    >
      {{ $t('error.importImpossible') }}
    </div>
    <VueDropzone
      v-if="!file"
      id="drop"
      :options="dropzoneOptions"
      @vdropzone-file-added="uploaded"
    />
    <Loader v-else-if="pending" />

    <BModal
      v-model="successModal"
      hide-header
      ok-only
      :ok-title="$t('general.close')"
      centered
      @ok="goBack"
      @hide="goBack"
    >
      <div class="text-center py-3">
        <i
          class="fas fa-check-circle text-success mb-3"
          style="font-size: 3rem"
        />
        <h5 class="mb-3">
          {{ $t('client.importTimetableSuccess') }}
        </h5>
        <div class="text-muted">
          <div>
            {{ $t('client.importTimetablePayers', { count: summary.updatedPayers }) }}
          </div>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  data: () => ({
    file: null,
    pending: false,
    error: null,
    successModal: false,
    summary: {
      updatedGroups: 0,
      updatedPayers: 0,
    },
  }),
  components: {
    VueDropzone,
  },
  computed: {
    ...mapGetters(['payeeId']),
    dropzoneOptions() {
      return {
        url: 'https://api.pagaspot.com',
        thumbnailWidth: 150,
        maxFilesize: 2,
        dictDefaultMessage: this.$t('import.upload'),
        headers: {},
      };
    },
  },
  methods: {
    ...mapActions(['importTimetablePlan']),
    uploaded(file) {
      this.pending = true;
      this.file = true;
      this.error = false;

      const formData = new FormData();
      formData.append('file', file);

      this.importTimetablePlan({ data: formData })
        .then(({ data }) => {
          this.summary = {
            updatedGroups: data.updatedGroups,
            updatedPayers: data.updatedPayers,
          };
          this.successModal = true;
        })
        .catch(() => {
          this.error = true;
          this.file = null;
        })
        .finally(() => {
          this.pending = false;
        });
    },
    goBack() {
      this.$router.push(`/payee/${this.payeeId}/settings/payers`);
    },
  },
  created() {
    this.$emit('backUrl', `/payee/${this.payeeId}/settings/payers`);
  },
};
</script>

<style lang="scss" scoped>
  #drop {
    border-radius: 20px;
    margin-top: 20px;
    font-family: 'Poppins';
  }
</style>
